import PropTypes from 'prop-types'

import { CloningStatusEnum, LeaguesTypes } from './constants'

// ---------------------------------------------------------------------------
// Round
// ---------------------------------------------------------------------------

export const RoundShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  playAt: PropTypes.string,
})

// ---------------------------------------------------------------------------
// League  (base shape returned by search_leagues / serialize_collection)
// ---------------------------------------------------------------------------

const leagueShapeFields = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  product: PropTypes.oneOf(Object.values(LeaguesTypes)).isRequired,
  first_round: RoundShape,
  last_round: RoundShape,
  total_rounds: PropTypes.number,
}

export const LeagueShape = PropTypes.shape(leagueShapeFields)

// ---------------------------------------------------------------------------
// EnhancedLeague  (step 2+: extends League with full rounds + capability flags)
// ---------------------------------------------------------------------------

export const EnhancedLeagueShape = PropTypes.shape({
  ...leagueShapeFields,
  rounds: PropTypes.arrayOf(RoundShape),
  // Capability flags — determine which config options are available
  has_managers: PropTypes.bool,
  has_stripe_account: PropTypes.bool,
  has_registration_payment_options: PropTypes.bool,
  golf_hub_page: PropTypes.bool,
})

// ---------------------------------------------------------------------------
// LeagueConfig  (per-league entry stored in session.data.leagues[leagueId])
// ---------------------------------------------------------------------------

export const LeagueConfigShape = PropTypes.shape({
  ...leagueShapeFields,
  league_name: PropTypes.string,
  // Cloning config options
  copy_player_roster: PropTypes.bool,
  tournament_library: PropTypes.bool,
  copy_logos: PropTypes.bool,
  copy_dft: PropTypes.bool,
  copy_all_portal_pages: PropTypes.bool,
  rounds_and_series: PropTypes.bool,
  open_registration: PropTypes.bool,
  stripe_account: PropTypes.bool,
  tournaments: PropTypes.bool,
  registration_payment_options: PropTypes.bool,
  copy_managers: PropTypes.bool,
  golf_hub_page: PropTypes.bool,
  // Additional configuration
  season: PropTypes.string,
  tour: PropTypes.string,
  subdomain: PropTypes.string,
  payment_model: PropTypes.string,
  mass_dates: PropTypes.arrayOf(PropTypes.string),
  // Round data (merged from EnhancedLeague)
  rounds: PropTypes.arrayOf(RoundShape),
  first_round: RoundShape,
  last_round: RoundShape,
  total_rounds: PropTypes.number,
})

// ---------------------------------------------------------------------------
// CloneLeaguesSession
// ---------------------------------------------------------------------------

export const CloneLeaguesSessionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  customer_id: PropTypes.string,
  user_id: PropTypes.string,
  created_by: PropTypes.string,
  name: PropTypes.string,
  status: PropTypes.oneOf(Object.values(CloningStatusEnum)),
  job_ids: PropTypes.arrayOf(PropTypes.string),
  created_at: PropTypes.string,
  updated_at: PropTypes.string,
  data: PropTypes.shape({
    cloningStep: PropTypes.number,
    leagues: PropTypes.objectOf(LeagueConfigShape),
  }),
})

// ---------------------------------------------------------------------------
// Pagination
// ---------------------------------------------------------------------------

export const PaginationShape = PropTypes.shape({
  page: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
})
